import { useMemo } from 'react';
import { getSupportEmail, Partners } from '@mesa-labs/mesa-ui';
import { useSelector } from '../redux/hooks';
import { useGetVendorQuery } from '../redux/api/vendor';

function useSupportEmail(): string {
  const vendorId = useSelector((state) => state.auth.vendorId);
  const selectedPartner = useSelector((state) => state.selectedPartner.selectedPartner);
  const onboardingPartnerId = useSelector((state) => state.onboarding.partnerId);
  const { data: vendorAggregate } = useGetVendorQuery({ id: vendorId! }, { skip: !vendorId });

  const partnerId = useMemo<Partners>(
    () => selectedPartner || onboardingPartnerId || (vendorAggregate?.onboardingPartnerId as Partners) || Partners.NO_PARTNER,
    [selectedPartner, onboardingPartnerId, vendorAggregate?.onboardingPartnerId],
  );

  return getSupportEmail(partnerId);
}

export default useSupportEmail;
